import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import CarouselImage from './CarouselImage';

const CarouselSide = ({ deal, selectedItem = 0, onSelect }) => {
  const getAIndex = (index) => {
    if (index + 1 > deal.images?.length) {
      return index - deal.images.length;
    }

    return index;
  };

  const Item = ({ image }) => {
    const showPlayIcon =
      image.position === selectedItem && deal?.video?.videoUrl;

    return (
      <>
        <li className="side__item" key={image.position}>
          <div
            onClick={() => onSelect(image.position)}
            onKeyDown={() => onSelect(image.position)}
            role="link"
            tabIndex="-1"
          >
            {showPlayIcon && (
              <FontAwesomeIcon
                icon={faPlayCircle}
                style={{ height: 20, width: 20 }}
              />
            )}
            <CarouselImage
              deal={deal}
              disableClickAction
              href={image.imageUrl}
              image={image}
              key={image.id}
              lazy
              load
            />
          </div>
        </li>
        <style jsx>{`
          .side__item {
            height: 50%;
            padding: 4px 0;
          }
        `}</style>
      </>
    );
  };

  const imageTop = deal.images[getAIndex(selectedItem + 1)];
  const imageBottom = deal.images[getAIndex(selectedItem + 2)];

  return (
    <>
      <ul className="side__wrapper">
        {imageTop && <Item image={imageTop} />}
        {imageBottom && <Item image={imageBottom} />}
      </ul>
      <style jsx>{`
        .side__wrapper {
          display: flex;
          flex-direction: column;
          list-style: none;
          margin: -4px 0;
          padding: 0;
          width: 100%;
        }
      `}</style>
    </>
  );
};

CarouselSide.propTypes = {
  deal: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  selectedItem: PropTypes.number,
};

export default CarouselSide;
